import { createSelector } from '@reduxjs/toolkit';
import { getQuotaLandingTariffsConfig } from 'reactApp/modules/features/features.selectors';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { baseTariffSpace } from 'reactApp/sections/QuotaLanding/Tariffs/Tariffs.types';
import { RootState } from 'reactApp/store';
import { Tariff } from 'reactApp/types/Billing';
import { ITariffsByTab } from 'reactApp/ui/TariffSectionNew/TariffsSection.types';
import { getTariffProductsByPeriods, isMonth6Period } from 'reactApp/utils/Period';

import { baseYearProduct } from './TariffsPlans.helpers';

export const getTariffsList = createSelector(
    [
        (state: RootState) => ProductsSelectors.getTariffsForQuotaLanding(state),
        (state, actionName: string) => ProductsSelectors.getPromoTariffs(state, actionName),
        (state, actionName) => actionName,
        (state) => getQuotaLandingTariffsConfig(state),
    ],
    (nonSpecialTariffs, promoTariffs, actionName, config): ITariffsByTab[] => {
        const tariffs: Tariff[] = actionName ? promoTariffs : nonSpecialTariffs;

        const list = tariffs.reduce((acc: ITariffsByTab[], tariffItem) => {
            const products = getTariffProductsByPeriods(
                tariffItem.products,
                tariffItem.products.some((item) => isMonth6Period(item.period))
            );
            if (products.yearProduct) {
                acc.push({
                    space: tariffItem.space,
                    tariffId: tariffItem.id,
                    isRecommended: tariffItem.id.includes(config.recommendedId),
                    products,
                });
            }

            return acc;
        }, []);

        list.unshift({
            tariffId: 'base',
            space: { ...baseTariffSpace },
            isRecommended: false,
            isBase: true,
            products: {
                yearProduct: {
                    ...baseYearProduct,
                    space: baseTariffSpace,
                },
                monthProduct: undefined,
            },
        });

        return list;
    }
);
